import { citationHref } from "./source-labels.js";

export function AskCitationChips({
  citations,
}: {
  citations: Array<{ sourceType: string; sourceId: string; title: string; excerpt?: string }>;
}) {
  return (
    <ul className="flex flex-wrap gap-1 pl-1">
      {citations.slice(0, 16).map((citation) => {
        const href = citationHref(citation.sourceType, citation.sourceId);
        const label = citation.title || citation.sourceId;
        return (
          <li key={`${citation.sourceType}:${citation.sourceId}`}>
            {href ? (
              <a
                href={href}
                className="inline-flex max-w-xs truncate rounded-soft-md bg-surface-muted px-2 py-0.5 text-[11px] text-fg-muted hover:text-fg"
                title={citation.sourceId}
              >
                {label}
              </a>
            ) : (
              <span
                className="inline-flex max-w-xs truncate rounded-soft-md bg-surface-muted px-2 py-0.5 text-[11px] text-fg-muted"
                title={citation.sourceId}
              >
                {label}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
